<div class="mb-3">
  @if (invalidUserMessage) {
    <div>
      <h1 class="pb-2 border-bottom fw-light" i18n>Ungültiger Benutzer</h1>
      <p>{{ invalidUserMessage }}</p>
    </div>
  }
  @if (!invalidUserMessage) {
    <div>
      <h1 class="pb-2 border-bottom fw-light" data-testid="welcome-appdata-heading" i18n>Willkommen</h1>
      @if (!user.parentsub) {
        <div>
          <p class="lead" i18n>
        Willkommen bei GetLocal. Vervollständigen Sie Ihre Daten, um die Registrierung
        abzuschließen!
      </p>
        </div>
      }
      @if (user.parentsub) {
        <div>
          <p class="lead" i18n>Willkommen bei GetLocal. Bitte bestätigen Sie Ihre Benutzeranmeldung!</p>
        </div>
      }
      @if (appProfileForm) {
        <form [formGroup]="appProfileForm">
          <input type="hidden" asp-for="ReturnUrl" />
          <input type="hidden" formControlName="subject" class="form-control form-control-sm" />
          <fieldset>
            <div class="row">
              <div class="col-sm-8">
                <div class="row mb-2">
                  @if (user.parentsub) {
                    <label class="col-sm-4 col-form-label col-form-label-sm" i18n>E-Mail</label>
                  } @else {
                    <label for="email" class="col-sm-4 col-form-label col-form-label-sm" i18n>Kontakt-E-Mail</label>
                  }
                  <div class="col-sm-8">
                    @if (user.parentsub) {
                      <div>
                        <label class="col-form-label col-form-label-sm">{{ user.email }}</label>
                      </div>
                    }
                    @if (!user.parentsub) {
                      <div>
                        <input
                          id="email"
                          type="email"
                          formControlName="email"
                          class="form-control form-control-sm"
                          data-testid="registration-contact-email"
                          [class.is-invalid]="fieldErrorsDue(f['email'])"
                          />
                        <small class="text-muted" i18n>
                          Die Kontaktadresse Ihres Kundenkontos: Käufer sehen sie auf Ihrer
                          Anbieterseite, sie steht auf Ihren Rechnungen, und Bestellungen an Sie
                          werden dorthin gemeldet. Vorbelegt mit Ihrer Anmelde-E-Mail — Sie können
                          hier eine andere Adresse eintragen und sie später unter „Meine Daten“ ändern.
                        </small>
                      </div>
                    }
                    <app-field-errors [control]="f['email']"></app-field-errors>
                  </div>
                </div>
                @if (!user.parentsub) {
                  <h6 class="fw-bold mt-3" i18n>Verkäuferdaten — Inhaber / Ansprechpartner</h6>
                  <p class="text-muted small" i18n>
                    Diese Angaben beschreiben den Verkäufer, z.B. auf Rechnungen: bei
                    Einzelunternehmern ohne Firmenbezeichnung der eigene Name, sonst die
                    Ansprechperson des Unternehmens. Ihr Benutzerkonto ist davon unabhängig.
                  </p>
                }
                <app-form-row label="Anrede" i18n-label>
                  <!-- backend #682: the stored value is a code (mr / ms / diverse / company)
                       and the word is ours to render. A native select rather than a Kendo
                       dropdown, deliberately: the option values ARE the codes, so an E2E test
                       picks one with selectOption('mr') without naming a translated word. -->
                  <select
                    id="salutation"
                    formControlName="salutation"
                    data-testid="welcome-salutation-select"
                    class="form-select form-select-sm"
                    >
                    <option value="" i18n>— bitte wählen —</option>
                    @for (option of salutationOptions; track option.code) {
                      <option [value]="option.code">{{ option.label }}</option>
                    }
                  </select>
                </app-form-row>
                <app-form-row label="Titel" i18n-label>
                  <input
                    id="title"
                    type="text"
                    formControlName="title"
                    class="form-control form-control-sm"
                    />
                </app-form-row>
                <app-form-row label="Vorname" i18n-label>
                  <input
                    id="firstName"
                    type="text"
                    formControlName="firstName"
                    class="form-control form-control-sm"
                    />
                </app-form-row>
                <app-form-row label="Mittelname" i18n-label>
                  <input
                    id="middleName"
                    type="text"
                    formControlName="middleName"
                    class="form-control form-control-sm"
                    />
                </app-form-row>
                <app-form-row label="Nachname" i18n-label>
                  <input
                    id="lastName"
                    type="text"
                    formControlName="lastName"
                    class="form-control form-control-sm"
                    />
                </app-form-row>
                @if (!user.parentsub) {
                  <app-form-row label="Firmenbezeichnung" i18n-label>
                    <input
                      id="companyName"
                      type="text"
                      formControlName="companyName"
                      class="form-control form-control-sm"
                      />
                  </app-form-row>
                  }
                  <app-form-row label="PLZ" i18n-label>
                    <input
                      id="zip"
                      type="text"
                      formControlName="zip"
                      class="form-control form-control-sm"
                      />
                  </app-form-row>
                  <app-form-row label="Straße" i18n-label>
                    <input
                      id="street"
                      type="text"
                      formControlName="street"
                      class="form-control form-control-sm"
                      />
                  </app-form-row>
                  <app-form-row label="Ort" i18n-label>
                    <input
                      id="city"
                      type="text"
                      formControlName="city"
                      class="form-control form-control-sm"
                      />
                  </app-form-row>
                  <app-form-row label="Land" i18n-label>
                    <kendo-dropdownlist
                      [data]="countryItems"
                      formControlName="countryId"
                      textField="name"
                      valueField="id"
                      [valuePrimitive]="true"
                    ></kendo-dropdownlist>
                  </app-form-row>
                </div>
              </div>
            </fieldset>
            <p class="lead mt-2" i18n>
        Zum Fortfahren müssen Sie die Allgemeinen Geschäftsbedingungen akzeptieren!
      </p>
            <div class="mb-2">
              <div class="col-sm-12">
                <input
                  name="acceptTaC"
                  id="acceptTaC"
                  class="ms-2 mt-2"
                  type="checkbox"
                  formControlName="acceptTaC"
                  />
                <label for="acceptTaC" class="col-form-label col-form-label-sm ms-1" i18n
                  >Ich akzeptiere die folgenden Allgemeinen Geschäftsbedingungen</label
                  >
                </div>
              </div>
              <div class="card">
                <fieldset>
                  <div class="card-title">
                    <div i18n>Allgemeine Geschäftsbedingungen</div>
                  </div>
                  <div class="card-body">
                    <div class="col-sm-12">
                      <div [innerHTML]="tac"></div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="form-group">
                <button
                  class="btn btn-primary m-2"
                  type="button"
                  data-testid="welcome-appdata-submit-button"
                  [asyncClick]="submitForm.bind(this)"
                  [disabled]="saveBtn.disabled || !appProfileForm || appProfileForm.invalid"
                  #saveBtn="asyncClick"
                  i18n
                  >
          @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Speichern
        </button>
              </div>
            </form>
          }
        </div>
      }
    </div>
